import { queryTransactionsReviews } from '../../util/api';
import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';

// ================ Action types ================ //

export const FETCH_REVIEWS_REQUEST = 'app/FeaturedReviews/FETCH_REVIEWS_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'app/FeaturedReviews/FETCH_REVIEWS_SUCCESS';
export const FETCH_REVIEWS_ERROR = 'app/FeaturedReviews/FETCH_REVIEWS_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchReviewsInProgress: false,
  fetchReviewsError: null,
  reviews: [],
};

const featuredReviewsReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_REVIEWS_REQUEST:
      return {
        ...state,
        fetchReviewsInProgress: true,
        reviews: [],
        fetchReviewsError: null,
      };
    case FETCH_REVIEWS_SUCCESS:

      return {
        ...state,
        reviews: payload?.data?.data,
        fetchReviewsInProgress: false,
      };
    case FETCH_REVIEWS_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, fetchReviewsInProgress: false, fetchReviewsError: payload };


    default:
      return state;
  }
};

export default featuredReviewsReducer;

// ================ Action creators ================ //

export const reviewsRequest = () => ({
  type: FETCH_REVIEWS_REQUEST,
});

export const reviewsSuccess = payload => ({
  type: FETCH_REVIEWS_SUCCESS,
  payload,
});

export const reviewsError = e => ({
  type: FETCH_REVIEWS_ERROR,
  error: true,
  payload: e,
});

export const fetchReviews = () => (dispatch, getState, sdk) => {
  dispatch(reviewsRequest());

  return queryTransactionsReviews()
    .then(response => {

      const sanitizeConfig = {};
      dispatch(addMarketplaceEntities(response, sanitizeConfig));
      dispatch(reviewsSuccess(response, sanitizeConfig));

      return response;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(reviewsError(error));
    });
};
